import { useEffect, useState } from 'react';
import {
  Cloud, Mail, Search, Calendar, Bell, Music, MessageSquare, Phone,
  Heart, Globe, MapPin, BookOpen, Brain, Shield, Cpu, Zap,
  DollarSign, Calculator, Clock, Users, FileText, Send, Camera,
  Compass, Home, Wrench, TrendingUp, Newspaper, Plane, Database,
  Activity, Rocket, Beaker, Dumbbell, Star, Terminal, GitBranch,
  type LucideIcon,
} from 'lucide-react';
import type { ToolCall } from '@/stores/chatStore';

const toolMeta: Record<string, { icon: LucideIcon; label: string; color: string }> = {
  weather:              { icon: Cloud,       label: 'Weather',          color: '#60a5fa' },
  mac_weather_current:  { icon: Cloud,       label: 'Weather',          color: '#60a5fa' },
  mac_weather_forecast: { icon: Cloud,       label: 'Forecast',         color: '#60a5fa' },
  send_email:           { icon: Mail,        label: 'Send Email',       color: '#a855f7' },
  read_email:           { icon: Mail,        label: 'Reading Email',    color: '#a855f7' },
  read_icloud_email:    { icon: Mail,        label: 'iCloud Email',     color: '#a855f7' },
  send_jarvis_email:    { icon: Send,        label: 'JARVIS Email',     color: '#a855f7' },
  web_search:           { icon: Search,      label: 'Web Search',       color: '#34d399' },
  perplexity_research:  { icon: Search,      label: 'Deep Research',    color: '#a78bfa' },
  search_knowledge:     { icon: BookOpen,    label: 'Knowledge Base',   color: '#818cf8' },
  list_calendar_events: { icon: Calendar,    label: 'Calendar',         color: '#fb923c' },
  create_calendar_event:{ icon: Calendar,    label: 'New Event',        color: '#fb923c' },
  mac_events_fetch:     { icon: Calendar,    label: 'Calendar',         color: '#fb923c' },
  mac_events_create:    { icon: Calendar,    label: 'New Event',        color: '#fb923c' },
  mac_calendars_list:   { icon: Calendar,    label: 'Calendars',        color: '#fb923c' },
  list_reminders:       { icon: Bell,        label: 'Reminders',        color: '#fbbf24' },
  set_reminder:         { icon: Bell,        label: 'Set Reminder',     color: '#fbbf24' },
  update_reminder:      { icon: Bell,        label: 'Update Reminder',  color: '#fbbf24' },
  mac_reminders_fetch:  { icon: Bell,        label: 'Reminders',        color: '#fbbf24' },
  mac_reminders_create: { icon: Bell,        label: 'New Reminder',     color: '#fbbf24' },
  mac_reminders_lists:  { icon: Bell,        label: 'Reminder Lists',   color: '#fbbf24' },
  now_playing:          { icon: Music,       label: 'Now Playing',      color: '#f472b6' },
  apple_music:          { icon: Music,       label: 'Apple Music',      color: '#f472b6' },
  spotify:              { icon: Music,       label: 'Spotify',          color: '#22c55e' },
  send_imessage:        { icon: MessageSquare, label: 'iMessage',       color: '#34d399' },
  mac_messages_fetch:   { icon: MessageSquare, label: 'Messages',       color: '#34d399' },
  call_user:            { icon: Phone,       label: 'Calling',          color: '#22d3ee' },
  health_summary:       { icon: Heart,       label: 'Health Data',      color: '#ef4444' },
  google_maps:          { icon: MapPin,      label: 'Maps',             color: '#f87171' },
  smart_directions:     { icon: Compass,     label: 'Directions',       color: '#38bdf8' },
  navigate:             { icon: Compass,     label: 'Navigation',       color: '#38bdf8' },
  get_my_location:      { icon: MapPin,      label: 'Location',         color: '#4ade80' },
  mac_location_current: { icon: MapPin,      label: 'Location',         color: '#4ade80' },
  mac_location_geocode: { icon: MapPin,      label: 'Geocode',          color: '#4ade80' },
  mac_maps_search:      { icon: MapPin,      label: 'Map Search',       color: '#f87171' },
  mac_maps_directions:  { icon: Compass,     label: 'Directions',       color: '#38bdf8' },
  mac_maps_eta:         { icon: Clock,       label: 'ETA',              color: '#38bdf8' },
  recall_memory:        { icon: Brain,       label: 'Recalling',        color: '#c084fc' },
  learn_fact:           { icon: Brain,       label: 'Learning',         color: '#c084fc' },
  about_person:         { icon: Users,       label: 'Person Lookup',    color: '#a78bfa' },
  search_contacts:      { icon: Users,       label: 'Contacts',         color: '#a78bfa' },
  mac_contacts_search:  { icon: Users,       label: 'Contacts',         color: '#a78bfa' },
  mac_contacts_create:  { icon: Users,       label: 'New Contact',      color: '#a78bfa' },
  mac_contacts_me:      { icon: Users,       label: 'My Card',          color: '#a78bfa' },
  update_contact:       { icon: Users,       label: 'Update Contact',   color: '#a78bfa' },
  self_diagnostic:      { icon: Shield,      label: 'Self Diagnostic',  color: '#f97316' },
  self_heal:            { icon: Wrench,      label: 'Self Repair',      color: '#f97316' },
  system_health:        { icon: Activity,    label: 'System Health',    color: '#22d3ee' },
  autonomy_status:      { icon: Cpu,         label: 'Autonomy Status',  color: '#06b6d4' },
  device_control:       { icon: Zap,         label: 'Device Control',   color: '#eab308' },
  smart_home_control:   { icon: Home,        label: 'Smart Home',       color: '#eab308' },
  financial_data:       { icon: DollarSign,  label: 'Finance',          color: '#4ade80' },
  trading_scan:         { icon: TrendingUp,  label: 'Trading Scan',     color: '#4ade80' },
  trading_signal:       { icon: TrendingUp,  label: 'Trading Signal',   color: '#4ade80' },
  trading_status:       { icon: TrendingUp,  label: 'Trading Status',   color: '#4ade80' },
  calculator:           { icon: Calculator,  label: 'Calculator',       color: '#94a3b8' },
  wolfram_alpha:        { icon: Calculator,  label: 'Wolfram Alpha',    color: '#fb923c' },
  date_time:            { icon: Clock,       label: 'Date & Time',      color: '#94a3b8' },
  news:                 { icon: Newspaper,   label: 'News',             color: '#60a5fa' },
  sports:               { icon: Star,        label: 'Sports',           color: '#fbbf24' },
  flight_tracker:       { icon: Plane,       label: 'Flight Tracker',   color: '#38bdf8' },
  camera_look:          { icon: Camera,      label: 'Camera',           color: '#22d3ee' },
  camera_ptz:           { icon: Camera,      label: 'Camera Move',      color: '#22d3ee' },
  mac_mini_screenshot:  { icon: Camera,      label: 'Screenshot',       color: '#22d3ee' },
  google_drive:         { icon: FileText,    label: 'Google Drive',     color: '#fbbf24' },
  github:               { icon: GitBranch,   label: 'GitHub',           color: '#e2e8f0' },
  slack:                { icon: MessageSquare, label: 'Slack',          color: '#e879f9' },
  send_push_notification: { icon: Bell,      label: 'Push Notification', color: '#fb923c' },
  scripture_lookup:     { icon: BookOpen,    label: 'Scripture',        color: '#fde68a' },
  nutrition_recipe:     { icon: Dumbbell,    label: 'Nutrition',        color: '#4ade80' },
  taste_profile:        { icon: Music,       label: 'Taste Profile',    color: '#f472b6' },
  personality_status:   { icon: Brain,       label: 'Personality',      color: '#c084fc' },
  learning_status:      { icon: BookOpen,    label: 'Learning Status',  color: '#818cf8' },
  research_briefing:    { icon: Rocket,      label: 'Research Brief',   color: '#a78bfa' },
  run_nanotech_sim:     { icon: Beaker,      label: 'Nanotech Sim',     color: '#22d3ee' },
  query_sim_results:    { icon: Database,    label: 'Sim Results',      color: '#22d3ee' },
  theorist_hypothesis:  { icon: Beaker,      label: 'Hypothesis',       color: '#818cf8' },
  mac_mini_exec:        { icon: Terminal,    label: 'Mac Mini',         color: '#94a3b8' },
  mac_mini_claude_code: { icon: Terminal,    label: 'Claude Code',      color: '#fb923c' },
  set_default_model:    { icon: Cpu,         label: 'Switch Model',     color: '#06b6d4' },
  set_wake_time:        { icon: Clock,       label: 'Wake Time',        color: '#fbbf24' },
  focus_session:        { icon: Zap,         label: 'Focus Session',    color: '#8b5cf6' },
  habit_tracker:        { icon: Star,        label: 'Habit Tracker',    color: '#fbbf24' },
  task_manager:         { icon: FileText,    label: 'Task Manager',     color: '#60a5fa' },
  throttle_control:     { icon: Activity,    label: 'Throttle',         color: '#f97316' },
  audit_log:            { icon: Shield,      label: 'Audit Log',        color: '#f97316' },
  workshop_mode:        { icon: Wrench,      label: 'Workshop',         color: '#eab308' },
  mcp_discovery:        { icon: Globe,       label: 'MCP Discovery',    color: '#06b6d4' },
  convert_maps_link:    { icon: MapPin,      label: 'Convert Link',     color: '#f87171' },
};

function getToolInfo(tool: string) {
  if (toolMeta[tool]) return toolMeta[tool];
  // Fallback: generate a reasonable label
  const label = tool.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
  return { icon: Zap, label, color: '#00d4ff' };
}

export default function ToolUseCard({ toolCall }: { toolCall: ToolCall }) {
  const [elapsed, setElapsed] = useState(0);
  const info = getToolInfo(toolCall.tool);
  const Icon = info.icon;
  const isDone = toolCall.status === 'done';

  useEffect(() => {
    if (isDone) return;
    const start = Date.now();
    // Stop the timer at 10 min (600s) so a tool call whose 'done'
    // event never arrives doesn't display as a 7-hour elapsed value
    // (Carter saw "26671.2s" on a stale message, 2026-05-04).
    const interval = setInterval(() => {
      const e = Date.now() - start;
      setElapsed(e);
      if (e > 600_000) clearInterval(interval);
    }, 100);
    return () => clearInterval(interval);
  }, [isDone]);

  const seconds = elapsed > 600_000 ? '600+' : (elapsed / 1000).toFixed(1);

  return (
    <div
      className="flex items-center gap-2.5 px-3 py-2 mb-1.5 border transition-all duration-300"
      style={{
        clipPath: 'polygon(0 4px, 4px 0, calc(100% - 4px) 0, 100% 4px, 100% calc(100% - 4px), calc(100% - 4px) 100%, 4px 100%, 0 calc(100% - 4px))',
        background: isDone
          ? 'rgba(0, 212, 255, 0.03)'
          : `rgba(${hexToRgb(info.color)}, 0.06)`,
        borderColor: isDone
          ? 'rgba(0, 212, 255, 0.12)'
          : `rgba(${hexToRgb(info.color)}, 0.25)`,
      }}
    >
      {/* Icon with pulse animation when running */}
      <div
        className="w-6 h-6 flex items-center justify-center flex-shrink-0"
        style={{
          clipPath: 'polygon(50% 0%, 93% 25%, 93% 75%, 50% 100%, 7% 75%, 7% 25%)',
          background: isDone
            ? 'rgba(0, 212, 255, 0.1)'
            : `rgba(${hexToRgb(info.color)}, 0.15)`,
        }}
      >
        <Icon
          size={12}
          style={{ color: isDone ? '#00d4ff' : info.color }}
          className={isDone ? '' : 'animate-pulse'}
        />
      </div>

      {/* Tool label */}
      <span
        className="text-[11px] font-mono font-medium flex-1"
        style={{ color: isDone ? 'rgba(0, 212, 255, 0.6)' : info.color }}
      >
        {info.label}
      </span>

      {/* Status indicator */}
      {isDone ? (
        <span className="text-[9px] font-mono text-jarvis-blue/40 uppercase tracking-wider">done</span>
      ) : (
        <div className="flex items-center gap-1.5">
          <span className="text-[9px] font-mono text-gray-500">{seconds}s</span>
          <div className="tool-scan-line w-8 h-3 relative overflow-hidden opacity-70">
            <div
              className="absolute inset-0 rounded-sm"
              style={{ background: `rgba(${hexToRgb(info.color)}, 0.08)` }}
            />
            <div
              className="tool-scan-bar absolute top-0 bottom-0 w-2"
              style={{ background: `linear-gradient(90deg, transparent, ${info.color}, transparent)` }}
            />
          </div>
        </div>
      )}
    </div>
  );
}

function hexToRgb(hex: string): string {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  return `${r}, ${g}, ${b}`;
}
